import ListMenuItem from "@/app/components/menu/listMenuItem";
import { OverlayMenuBaseProps } from "@/app/components/menu/overlayMenuSystem";
import style from "@/app/components/menu/overlayMenuSystem.module.scss";
import SupportMenuFAQ from "@/app/layouts/standard/header/supportMenuFAQ";
import { loadZendesk } from "@/app/layouts/standard/header/utils/zendeskUtils";
import ChatSVG from "public/next-public/common/icons/chat-icon.svg";
import PhoneSVG from "public/next-public/common/icons/phone.svg";
import QuestionMarkSVG from "public/next-public/common/icons/question-mark.svg";
import { useDispatch } from "react-redux";
import supportMenuStyles from "./supportMenu.module.scss";

export default function SupportMenu({ navigateToSubMenuCallback, closeCallback }: OverlayMenuBaseProps) {
  const dispatch = useDispatch();
  // const showNotification = useSelector((state: AppState) => state.zendeskNotificationSlice.chatHidden);
  const showNotification = false; // TODO: add notification in later story

  const handleZendeskChatClick = async () => {
    await loadZendesk(dispatch, true);

    if (closeCallback) {
      closeCallback();
    }
  };

  return (
    <div className={`${style.overlayMenuContainer} ${style.supportMenu}`}>
      <div className={style.menuListItemContainer}>
        <ListMenuItem
          id="support-contact"
          iconDecorationPrefix={<PhoneSVG />}
          descriptionSuffix="(800) 517-1997"
          linkTo="/contact-us"
        >
          Contact Us
        </ListMenuItem>
        <div className={showNotification ? supportMenuStyles.withNotification : undefined}>
          <ListMenuItem id="live-chat" iconDecorationPrefix={<ChatSVG />} customClickCallback={handleZendeskChatClick}>
            Live Chat
          </ListMenuItem>
          {showNotification && <span className={supportMenuStyles.notificationBadge} aria-label="Chat available" />}
        </div>
        <ListMenuItem
          id="support-faq"
          iconDecorationPrefix={<QuestionMarkSVG />}
          subMenu={<SupportMenuFAQ headerText={"FAQs"} />}
          navigateToSubMenuCallback={navigateToSubMenuCallback}
        >
          FAQs
        </ListMenuItem>
      </div>
    </div>
  );
}
